export enum RoleEnum {
    Admin = "Admin",
    User = "User",
    Advisor = "Advisor"
}
